import { render, staticRenderFns } from "./deposit-table-checking-data.vue?vue&type=template&id=45968de4"
import script from "./deposit-table-checking-data.vue?vue&type=script&lang=js"
export * from "./deposit-table-checking-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports